module.exports = __webpack_public_path__ + "static/img/漢來美食.425aca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/漢來美食.png?20181011
// module id = 65SF
// module chunks = 1